// src/entities/Session/model.ts
import { defineStore } from 'pinia'
import { ref } from 'vue'

const TOKEN_KEY = 'vpn_auth_token'

export const useSessionStore = defineStore('session', () => {
  const token = ref<string | null>(localStorage.getItem(TOKEN_KEY))

  const setToken = (newToken: string) => {
    token.value = newToken
    localStorage.setItem(TOKEN_KEY, newToken)
  }

  const clearToken = () => {
    token.value = null
    localStorage.removeItem(TOKEN_KEY)
  }

  const isAuthenticated = () => {
    return !!token.value
  }

  return {
    token,
    setToken,
    clearToken,
    isAuthenticated,
  }
})
